/**
 * Kanban board секций подтверждений / ОС.
 * Дата: 17.07.2026
 */
import { Badge, Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import type { InteractionEvent, InteractionEventType } from '@/types/interaction';
import { InteractionEventCard } from './InteractionEventCard';

export type InteractionsKanbanColumn = {
  type: InteractionEventType;
  label: string;
  icon: JSX.Element;
  accentClass: string;
};

export function InteractionsKanban({
  columnsConfig,
  columns,
  summaryMap,
}: {
  columnsConfig: InteractionsKanbanColumn[];
  columns: Record<string, InteractionEvent[]>;
  summaryMap: Record<InteractionEventType, number>;
}) {
  return (
    <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
      {columnsConfig.map((column) => {
        const items = columns[column.type] || [];
        return (
          <Card
            key={column.type}
            className={`border-shell-border bg-shell-surface shadow-none border-l-4 ${column.accentClass}`}
          >
            <CardHeader className="space-y-0 pb-2 pt-4">
              <CardTitle className="flex items-center gap-2 text-sm font-extrabold tracking-tight text-shell-text">
                {column.icon}
                <span className="min-w-0 truncate">{column.label}</span>
                <Badge variant="secondary" className="ml-auto shrink-0">
                  {summaryMap[column.type] || 0}
                </Badge>
              </CardTitle>
            </CardHeader>
            <CardContent className="max-h-[600px] space-y-2 overflow-y-auto pt-0">
              {items.length === 0 ? (
                <p className="py-6 text-center text-sm text-shell-muted">Нет событий</p>
              ) : (
                items.map((event) => <InteractionEventCard key={event.id} event={event} />)
              )}
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
